const color = {
  primary: '#C30D23',
};

export default color;
